import PropTypes from 'prop-types'
import {splitIntoInstallments} from './paypalMethods'
import '../../../styles/paypal.css'

const propTypes = {
    amount: PropTypes.string.isRequired,
    formatAmount: PropTypes.func.isRequired
}

const DAYS_BETWEEN_PAYMENTS = 14

function scheduleLabel(index) {
    if (index === 0) return 'Today'

    const date = new Date()
    date.setDate(date.getDate() + index * DAYS_BETWEEN_PAYMENTS)
    return date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'})
}

/**
 * The Pay Later breakdown shown under the method list. PayPal owns the real offer — the exact
 * amounts and dates are confirmed in its own flow — so this is presented as an estimate of the
 * standard Pay in 4 schedule rather than as agreed terms.
 */
const PaypalPayLaterPanel = ({amount, formatAmount}) => {
    const installments = splitIntoInstallments(amount)

    if (!installments.length) return null

    return (
        <div className="pp-paylater-panel">
            <div className="pp-paylater-lead">4 interest-free payments, first one today.</div>
            <div className="pp-installments">
                {installments.map((installment, index) => (
                    <div className="pp-installment" key={index}>
                        <span className="pp-installment-amount">{formatAmount(installment)}</span>
                        <span className="pp-installment-when">{scheduleLabel(index)}</span>
                    </div>
                ))}
            </div>
            <div className="pp-paylater-note">Estimated schedule — PayPal confirms your exact dates and amounts before you pay.</div>
        </div>
    )
}

PaypalPayLaterPanel.propTypes = propTypes

export default PaypalPayLaterPanel
